import React from 'react';
import {
    CheckCircle2,
    TrendingUp,
    AlertTriangle,
    XCircle
} from 'lucide-react';

/**
 * Metrics Cards Component
 * Displays validation status metrics in card format
 * @param {Object} props - Component props
 * @param {Object} props.statusCounts - Status count object with excellent, good, warning, critical counts
 * @returns {JSX.Element} Metrics cards grid
 */
export function MetricsCards({ statusCounts = {} }) {
    const {
        excellent = 0,
        good = 0,
        warning = 0,
        critical = 0
    } = statusCounts;

    const metricsData = [
        {
            id: 'excellent',
            count: excellent,
            label: 'Excellent (90%+)',
            description: 'High-performing stores with minimal issues',
            icon: CheckCircle2,
            bgColor: 'bg-emerald-50',
            iconColor: 'text-emerald-600'
        },
        {
            id: 'good',
            count: good,
            label: 'Good (70-89%)',
            description: 'Performing well with minor improvements needed',
            icon: TrendingUp,
            bgColor: 'bg-blue-50',
            iconColor: 'text-blue-600'
        },
        {
            id: 'warning',
            count: warning,
            label: 'Warning (50-69%)',
            description: 'Requires attention and improvements',
            icon: AlertTriangle,
            bgColor: 'bg-amber-50',
            iconColor: 'text-amber-600'
        },
        {
            id: 'critical',
            count: critical,
            label: 'Critical (Under 50%)',
            description: 'Immediate action required',
            icon: XCircle,
            bgColor: 'bg-red-50',
            iconColor: 'text-red-600'
        }
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {metricsData.map(({ id, count, label, description, icon: Icon, bgColor, iconColor }) => (
                <div key={id} className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
                    <div className="flex items-center justify-between mb-4">
                        <div className={`p-3 rounded-full ${bgColor}`}>
                            <Icon size={24} className={iconColor} />
                        </div>
                        <div className="text-right">
                            <div className="text-2xl font-bold text-slate-900">{count}</div>
                            <div className="text-sm text-slate-600">{label}</div>
                        </div>
                    </div>
                    <div className="text-xs text-slate-500">
                        {description}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default MetricsCards;
